export default __webpack_public_path__ + "static/media/placeholder_dummy2016-schauspieler01-de.e15deadb.png";